import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function MyPayments() {
  const navigate = useNavigate();
  const [labour, setLabour]     = useState(null);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [filter, setFilter]     = useState("all");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { label:"Dashboard",     emoji:"🏠", path:"/labour/dashboard" },
    { label:"My Attendance", emoji:"📅", path:"/labour/attendance" },
    { label:"My Salary",     emoji:"💰", path:"/labour/salary" },
    { label:"My Payments",   emoji:"💳", path:"/labour/payments", active:true },
    { label:"Profile",       emoji:"👤", path:"/labour/profile" },
  ];

  const TYPE = {
    advance:  { label:"Advance",  bg:"#FEF2F2", border:"#FECACA", tc:"#DC2626",  emoji:"📤" },
    payment:  { label:"Payment",  bg:"#D1FAE5", border:"#A7F3D0", tc:"#059669",  emoji:"💵" },
    salary:   { label:"Salary",   bg:"#D1FAE5", border:"#A7F3D0", tc:"#059669",  emoji:"💵" },
    overtime: { label:"Overtime", bg:"#DBEAFE", border:"#BAE6FD", tc:"#0369A1",  emoji:"⏱️" },
    daily:    { label:"Daily",    bg:"#FEF3C7", border:"#FDE68A", tc:"#D97706",  emoji:"📅" },
    weekly:   { label:"Weekly",   bg:"#EDE9FE", border:"#DDD6FE", tc:"#7C3AED",  emoji:"🗓️" },
    final:    { label:"Final",    bg:"#D1FAE5", border:"#A7F3D0", tc:"#059669",  emoji:"✅" },
  };

  useEffect(()=>{
    const fetchAll = async()=>{
      try{
        const profileRes = await api.get("/labour/me");
        const lab = profileRes.data.labour;
        setLabour(lab);
        // Try /payment/my first, fallback to /:id
        try {
          const payRes = await api.get("/payment/my");
          setPayments(payRes.data?.data || payRes.data || []);
        } catch(_) {
          const payRes = await api.get(`/payment/${lab._id}`);
          setPayments(payRes.data?.payments || payRes.data || []);
        }
      }catch(e){console.error(e);}
      finally{setLoading(false);}
    };
    fetchAll();
  },[]);

  const filtered = filter==="all" ? payments : payments.filter(p=>p.type===filter);
  const sorted   = [...filtered].sort((a,b)=>new Date(b.date||b.createdAt)-new Date(a.date||a.createdAt));

  const totalReceived = payments.filter(p=>p.type!=="advance").reduce((s,p)=>s+p.amount,0);
  const totalAdvance  = payments.filter(p=>p.type==="advance").reduce((s,p)=>s+p.amount,0);
  const totalOT       = payments.filter(p=>p.type==="overtime").reduce((s,p)=>s+p.amount,0);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
        @keyframes spin{to{transform:rotate(360deg)}}
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        body{font-family:'Plus Jakarta Sans',sans-serif;background:#FAF7F4;}
        .sidebar{width:220px;flex-shrink:0;background:#fff;border-right:1.5px solid #E7E5E4;padding:24px 14px;display:flex;flex-direction:column;gap:6px;position:sticky;top:0;height:100vh;overflow-y:auto;}
        .topbar{display:none;}
        .hamburger{display:none;align-items:center;justify-content:center;width:40px;height:40px;border-radius:10px;border:1.5px solid #E7E5E4;background:#fff;cursor:pointer;flex-shrink:0;}
        .sidebar-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:40;}
        .nav-btn{display:flex;align-items:center;gap:9px;width:100%;padding:10px 12px;border-radius:10px;border:none;background:none;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;font-weight:600;color:#78716C;cursor:pointer;transition:background .15s,color .15s;text-align:left;}
        .nav-btn:hover,.nav-btn.active{background:#FEF3C7;color:#D97706;}
        .nav-btn.danger:hover{background:#FEF2F2;color:#DC2626;}
        .pay-row{transition:background .15s;}
        .pay-row:hover{background:#FFFBF7;}
        .tab-btn{padding:7px 14px;border-radius:20px;border:1.5px solid #E7E5E4;background:#fff;font-family:'Plus Jakarta Sans',sans-serif;font-size:12px;font-weight:700;color:#78716C;cursor:pointer;transition:all .15s;white-space:nowrap;}
        .tab-btn:hover{border-color:#D97706;color:#D97706;}
        .tab-btn.active{background:#FEF3C7;border-color:#D97706;color:#92400E;}
        @media(max-width:768px){
          .sidebar{position:fixed;left:0;top:0;z-index:50;transform:translateX(-100%);transition:transform .28s ease;height:100%;}
          .sidebar.open{transform:translateX(0);}
          .sidebar-overlay.open{display:block;}
          .topbar{display:flex;align-items:center;gap:12px;padding:14px 16px;background:#fff;border-bottom:1.5px solid #E7E5E4;position:sticky;top:0;z-index:30;}
          .hamburger{display:flex;}
          .main-wrap{flex-direction:column!important;}
          .main-content{padding:16px!important;}
          .desktop-table{display:none!important;}
          .mobile-cards{display:block!important;}
        }
        .mobile-cards{display:none;}
        @media(min-width:769px) and (max-width:1100px){.sidebar{width:190px;}}
      `}</style>

      <div className="main-wrap" style={{display:"flex",minHeight:"100vh",fontFamily:"'Plus Jakarta Sans',sans-serif",background:"#FAF7F4"}}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={()=>setSidebarOpen(false)}/>

        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"28px",padding:"0 4px"}}>
            <div style={{width:"36px",height:"36px",background:"linear-gradient(135deg,#92400E,#D97706)",borderRadius:"10px",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <span style={{fontSize:"18px"}}>🪚</span>
            </div>
            <div>
              <p style={{fontWeight:"800",fontSize:"15px",color:"#1C1917"}}>Craftigo</p>
              <p style={{fontSize:"11px",color:"#A8A29E",fontWeight:"500"}}>Labour Panel</p>
            </div>
          </div>
          <p style={{fontSize:"11px",fontWeight:"700",color:"#C4B5A4",letterSpacing:"0.7px",textTransform:"uppercase",padding:"0 6px",marginBottom:"6px"}}>Menu</p>
          {navItems.map(n=>(
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`} onClick={()=>{navigate(n.path);setSidebarOpen(false);}}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{flex:1}}/>
          <div style={{padding:"12px",background:"#E0F2FE",borderRadius:"12px",border:"1px solid #BAE6FD",marginBottom:"10px"}}>
            <p style={{fontSize:"12px",fontWeight:"700",color:"#0369A1"}}>🔨 Labour</p>
            <p style={{fontSize:"11px",color:"#0369A1",marginTop:"2px",opacity:.8}}>{labour?.name||"..."}</p>
          </div>
          <button className="nav-btn danger" onClick={()=>{localStorage.clear();navigate("/login");}}>🚪 Logout</button>
        </aside>

        <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0}}>
          <div className="topbar">
            <button className="hamburger" onClick={()=>setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6" x2="21" y2="6" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{fontWeight:"800",fontSize:"16px",color:"#1C1917"}}>💳 My Payments</span>
          </div>

          <main className="main-content" style={{padding:"28px 28px",flex:1,overflowY:"auto"}}>
            <div style={{marginBottom:"20px"}}>
              <h1 style={{fontSize:"24px",fontWeight:"800",color:"#1C1917",letterSpacing:"-0.5px"}}>My Payments</h1>
              <p style={{fontSize:"13px",color:"#A8A29E",marginTop:"3px"}}>{payments.length} total transactions</p>
            </div>

            {/* Summary */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:"12px",marginBottom:"20px"}}>
              {[
                {label:"Total Received", val:`₹${totalReceived}`, bg:"#D1FAE5",border:"#A7F3D0",tc:"#059669"},
                {label:"Advance Given",  val:`₹${totalAdvance}`,  bg:"#FEF2F2",border:"#FECACA",tc:"#DC2626"},
                {label:"OT Payments",    val:`₹${totalOT}`,       bg:"#DBEAFE",border:"#BAE6FD",tc:"#0369A1"},
              ].map(s=>(
                <div key={s.label} style={{padding:"14px 16px",borderRadius:"14px",background:s.bg,border:`1.5px solid ${s.border}`}}>
                  <p style={{fontSize:"20px",fontWeight:"800",color:s.tc}}>{s.val}</p>
                  <p style={{fontSize:"12px",color:s.tc,opacity:.8,marginTop:"3px"}}>{s.label}</p>
                </div>
              ))}
            </div>

            {/* Filter tabs */}
            <div style={{display:"flex",gap:"8px",flexWrap:"wrap",marginBottom:"16px"}}>
              {["all","advance","payment","overtime","daily","weekly","final"].map(t=>(
                <button key={t} className={`tab-btn ${filter===t?"active":""}`} onClick={()=>setFilter(t)}>
                  {t==="all"?"All":TYPE[t]?.label||t}
                </button>
              ))}
            </div>

            {/* DESKTOP TABLE */}
            <div className="desktop-table" style={{background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"16px",overflow:"hidden"}}>
              <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 2fr",padding:"12px 20px",background:"#FAF7F4",borderBottom:"1.5px solid #E7E5E4"}}>
                {["Date","Amount","Type","Remark"].map(h=>(
                  <span key={h} style={{fontSize:"11px",fontWeight:"700",color:"#A8A29E",letterSpacing:"0.6px",textTransform:"uppercase"}}>{h}</span>
                ))}
              </div>
              {loading ? (
                <div style={{padding:"48px",textAlign:"center"}}>
                  <div style={{width:"32px",height:"32px",border:"3px solid #FDE68A",borderTop:"3px solid #D97706",borderRadius:"50%",animation:"spin .7s linear infinite",margin:"0 auto"}}/>
                </div>
              ) : sorted.length===0 ? (
                <div style={{padding:"48px",textAlign:"center"}}>
                  <p style={{fontSize:"32px",marginBottom:"10px"}}>💳</p>
                  <p style={{color:"#78716C",fontWeight:"600"}}>No payments found</p>
                </div>
              ) : sorted.map((p,i)=>{
                const d  = new Date(p.date||p.createdAt);
                const tp = TYPE[p.type]||{label:p.type,bg:"#F5F5F4",border:"#E7E5E4",tc:"#78716C",emoji:"💰"};
                return (
                  <div key={p._id||i} className="pay-row"
                    style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 2fr",padding:"13px 20px",borderBottom:i<sorted.length-1?"1px solid #F5F5F4":"none",alignItems:"center"}}>
                    <p style={{fontSize:"14px",fontWeight:"600",color:"#1C1917"}}>{d.toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})}</p>
                    <p style={{fontSize:"14px",fontWeight:"800",color:"#059669"}}>₹{p.amount}</p>
                    <span style={{display:"inline-flex",alignItems:"center",gap:"4px",padding:"3px 10px",borderRadius:"20px",fontSize:"11px",fontWeight:"700",background:tp.bg,border:`1px solid ${tp.border}`,color:tp.tc,width:"fit-content"}}>
                      {tp.emoji} {tp.label}
                    </span>
                    <p style={{fontSize:"13px",color:"#78716C"}}>{p.remark||"—"}</p>
                  </div>
                );
              })}
            </div>

            {/* MOBILE CARDS */}
            <div className="mobile-cards">
              {loading ? (
                <div style={{padding:"48px",textAlign:"center"}}>
                  <div style={{width:"32px",height:"32px",border:"3px solid #FDE68A",borderTop:"3px solid #D97706",borderRadius:"50%",animation:"spin .7s linear infinite",margin:"0 auto"}}/>
                </div>
              ) : (
                <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
                  {sorted.map((p,i)=>{
                    const d  = new Date(p.date||p.createdAt);
                    const tp = TYPE[p.type]||{label:p.type,bg:"#F5F5F4",border:"#E7E5E4",tc:"#78716C",emoji:"💰"};
                    return (
                      <div key={p._id||i} style={{background:"#fff",border:"1.5px solid #E7E5E4",borderRadius:"14px",padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:"12px"}}>
                        <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
                          <div style={{width:"38px",height:"38px",borderRadius:"10px",background:tp.bg,border:`1.5px solid ${tp.border}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",flexShrink:0}}>{tp.emoji}</div>
                          <div>
                            <p style={{fontSize:"14px",fontWeight:"700",color:"#1C1917"}}>₹{p.amount}</p>
                            <p style={{fontSize:"12px",color:"#A8A29E"}}>{d.toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})}</p>
                            {p.remark&&<p style={{fontSize:"11px",color:"#78716C",marginTop:"2px"}}>{p.remark}</p>}
                          </div>
                        </div>
                        <span style={{padding:"4px 10px",borderRadius:"20px",fontSize:"11px",fontWeight:"700",background:tp.bg,border:`1px solid ${tp.border}`,color:tp.tc,flexShrink:0}}>{tp.label}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    </>
  );
}